const orsBaseUrl = process.env.GATSBY_ORS_BASE_URL;

export const OrsRoutes = {
  OrsBase: orsBaseUrl,
  CreateReview: `${orsBaseUrl}/create-submission`,
  EditReview: `${orsBaseUrl}/submission/:reviewId/edit`,
  SystemManagement: `${orsBaseUrl}/system-management/users`,
  SendNotifications: `${orsBaseUrl}/submission/:reviewId/sendnotification/:status`,
};
